import AlgoliaSearchSupport from 'algolia_search_support'
import { loadTemplate } from "utils/load_template"
import { Controller } from '@hotwired/stimulus'
import Quimbee from 'quimbee'

export default class extends Controller {
  static values = {
    hideCle: Boolean
  }

  initialize() {
    const onSelect = function(event) { window.location = event.item.path }
    const filters = this.hideCleValue ? Quimbee.data.algolia.contentSearch.defaultFiltersHideCle : ""
    const search = new AlgoliaSearchSupport('header .search-input', this.suggestionTemplate, onSelect, filters, { panel: "header-search-results" })
    search.initialize()
  }

  suggestionTemplate(suggestion) {
    const contentType = suggestion.content_type === "Quizzes" ? "Quiz" : suggestion.content_type.slice(0, -1)
    const description = suggestion.class_name === "Case" ? suggestion.description : ""
    const hasVideo = suggestion.metadata ? (suggestion.metadata.find((me) => me.key === "has_video") || {}).value : false
    const videoIndicator = hasVideo ? loadTemplate("video-icon-template") : ""

    const url = new URL(suggestion.path, window.location.origin)
    url.searchParams.set("origin", "quimbee_search")
    const path = url.pathname + url.search

    return loadTemplate('suggestion-template').interpolateObject(
      {
        title: suggestion._highlightResult.title.value,
        contentType: contentType,
        description: description,
        videoIndicator: videoIndicator,
        url: path
      },
      (value) => { return value.replaceAll("__aa-highlight__", "<span class='aa-highlight'>").replaceAll("__/aa-highlight__", "</span>")}
    )
  }
}
